import AreasList from "./AreasList";

export default AreasList;
